import React from 'react'
import T from 'prop-types'
import { styled } from '@mui/material/styles'
import { Box, IconButton, Stack, Typography } from '@mui/material'
import KeyboardDoubleArrowDownIcon from '@mui/icons-material/KeyboardDoubleArrowDown'
import DiamondOutlinedIcon from '@mui/icons-material/DiamondOutlined'
import FavoriteIcon from '@mui/icons-material/Favorite'
import FavoriteBorderIcon from '@mui/icons-material/FavoriteBorder'
import {
  getFormattedOptionAmount,
  getFormattedReconditioningEstCost,
} from 'lib/carDetailsLib'

import AppealingIndex from 'components/atoms/AppealingIndex'

import CarDetailsItem from './CarDetailsItem'

const classes = {
  carDetailsItem: 'car-details-item',
  carDetailsItemTitle: 'car-details-item-title',
  carDetailsItemIcon: 'car-details-item-icon',
  carDetailsItemValue: 'car-details-item-value',
}
const Root = styled('div')(({ theme }) => ({
  [`&.${classes.carDetailsItem}`]: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    paddingTop: theme.spacing(1),
    paddingBottom: theme.spacing(1),
    [`& .${classes.carDetailsItemIcon}`]: {
      marginRight: theme.spacing(1),
    },
    [`& .${classes.carDetailsItemTitle}`]: {
      display: 'flex',
      alignItems: 'center',
    },
  },
}))

export default function CarDetailsRightColumn({
  car,
  price,
  maxPrice,
  showPriceRange = true,
  showAppealing,
  bottom,
  onToggleFavorite,
  showFavoriteReadOnly = false,
}) {
  const numberFormatter = new Intl.NumberFormat('it-IT')

  const handleFavoriteClick = (e) => {
    e.stopPropagation()
    if (onToggleFavorite) {
      onToggleFavorite()
    }
  }

  const showFavoriteIcon = onToggleFavorite || showFavoriteReadOnly

  return (
    <Root>
      <Stack direction="row" alignItems="center" className={classes.carTitle}>
        <Typography
          variant="body1"
          color="textPrimary"
          className={classes.carTitle}
        >
          <strong>
            {car.brand} {car.model}
          </strong>
        </Typography>
        {showFavoriteIcon && (
          <IconButton
            size="small"
            onClick={handleFavoriteClick}
            sx={{ padding: 0.5 }}
            aria-label={
              car.favorite ? 'Remove from favorites' : 'Add to favorites'
            }
            disabled={!onToggleFavorite}
          >
            {car.favorite ? (
              <FavoriteIcon sx={{ fontSize: 20, color: 'red' }} />
            ) : (
              <FavoriteBorderIcon sx={{ fontSize: 20 }} />
            )}
          </IconButton>
        )}
      </Stack>
      <Typography
        variant="body2"
        color="textSecondary"
        className={classes.carSubtitle}
        sx={{ mb: 1 }}
      >
        {car.title}
      </Typography>
      <Stack direction="row" justifyContent="space-between" alignItems="center">
        <Stack>
          <Typography
            variant="body1"
            color="primary"
            className={classes.carPrice}
          >
            <strong>
              €{' '}
              {(price !== undefined && price) || car.marketPrice
                ? numberFormatter.format(
                    (price !== undefined && price) || car.marketPrice
                  )
                : '-'}
              {showPriceRange &&
                maxPrice &&
                ` - € ${numberFormatter.format(maxPrice)}`}
            </strong>
          </Typography>
          <Stack direction="row">
            <CarDetailsItem
              icon={KeyboardDoubleArrowDownIcon}
              value={getFormattedReconditioningEstCost(
                car.reconditioningEstCost
              )}
              valueProps={{ variant: 'caption' }}
            />
            <Box pr={2} />
            <CarDetailsItem
              icon={DiamondOutlinedIcon}
              value={getFormattedOptionAmount(car.optionAmount)}
              valueProps={{ variant: 'caption' }}
            />
          </Stack>
        </Stack>
        {showAppealing && (
          <div>
            <AppealingIndex value={car.appealing} />
          </div>
        )}
      </Stack>
      {bottom}
    </Root>
  )
}

CarDetailsRightColumn.propTypes = {
  car: T.object.isRequired,
  price: T.number,
  maxPrice: T.number,
  showPriceRange: T.bool,
  showAppealing: T.bool,
  bottom: T.node,
  onToggleFavorite: T.func,
  showFavoriteReadOnly: T.bool,
}
